import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { formatText } from '../../../../helpers/value'
import { getListYears } from '../../helper'
import { getReportItems } from './thunk'

const formatGroupYears = (groupYearsStr) => {
  return groupYearsStr === '' || groupYearsStr
    ? getListYears(groupYearsStr).join(', ')
    : formatText(groupYearsStr)
}

const slice = createSlice({
  name: 'common/order/businessCreditReport',
  initialState: {
    data: [],
    isLoading: true,
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.data = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReportItems.pending, (state) => {
      state.isLoading = true
      state.data = []
    })
    builder.addCase(getReportItems.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload.map((item) => ({
        ...item,
        availableData: formatGroupYears(item?.availableData),
        readyVersionReportingYear: formatGroupYears(
          item?.readyVersionReportingYear,
        ),
      }))
    })
    builder.addCase(getReportItems.rejected, (state, action) => {
      state.isLoading = action.payload?.isLoading
    })
  },
})

export const selectReportData = (state) => state[slice.name].data
export const selectIsLoading = (state) => state[slice.name].isLoading

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
